<template>
    <div class="job-item-box" @click="handleClickToDetail(cardData)" :class="{'downloadCardStyle': cardType === 'download'}" @mouseenter="showFixed" @mouseleave="hiddenFixed">
      <div class="job-base">
        <p class="job-title">{{cardData.job_post}}</p>
        <p class="job-salary">{{cardData.display_salary}}</p>
      </div>
      <div class="job-info">

        <span class="tag-menu">{{(cardData.city_names && cardData.city_names[0]) || '全国'}}</span>
        <span class="tag-menu" v-if="cardData.job_nature === '校招'">{{ cardData.job_nature }}</span>
        <span class="tag-menu" v-if="cardData.job_nature === '全职'">{{!cardData.display_experience || cardData.display_experience === '不限' ? '经验不限' : (cardData.display_experience === '1年以下' ? '1年以内' : cardData.display_experience)}}</span>
        <span class="tag-menu" v-if="cardData.job_nature === '校招'">{{ cardData.graduate_times | formatGraduationYear }}</span>
        <span class="tag-menu">{{!cardData.degree_name || cardData.degree_name === '不限' ? '学历不限' : cardData.degree_name}}</span>
        <span class="tag-menu" v-if="cardData.intern_frequency && cardData.job_nature === '实习'">{{ `${cardData.intern_frequency}天/周` }}</span>
        <span class="tag-menu" v-if="cardData.intern_duration && cardData.job_nature === '实习'">{{ cardData.intern_duration }}</span>
        <template v-for="(tagItem, tagIndex) in (cardData.job_tags || [])">
          <span class="tag-menu" :key="'tag-menu' + tagIndex">{{tagItem}}</span>
        </template>

      </div>
      <div class="company-info">
        <img :src="cardData.company_logo" class="job-company-logo"/>
        <span v-if="cardData.company_nick_name || cardData.company_name">{{cardData.company_nick_name || cardData.company_name}}</span>
        <span v-if="cardData.company_industry">{{cardData.company_industry}}</span>
        <span v-if="cardData.phase">{{ cardData.phase }}</span>
      </div>
      <div class="matching">
        <span class="icon">简</span><span class="content">该职位与你的简历匹配度为{{cardData.match_score || Math.floor(Math.random() * 2) + 97 }}%</span>
      </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    // 卡片类型
    // 可能的值：1. download 下载 2. jobtab 职位tab
    cardType: {
      type: String,
      default: 'download'
    },
    // 卡片数据
    cardData: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('editor', [ 'jobTabCardDialogTimer', 'jobTabCardContentScrollY', 'showJobTabCardDialog', 'showJobTabCardDialogSelf', 'showJobTabCardDialogData' ])
  },
  filters: {
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('/') + '届'
    }
  },
  methods: {
    ...mapMutations('editor', ['setJobTabCardDialogTimer', 'setJobTabCardDialogTop', 'setShowJobTabCardDialog', 'setShowJobTabCardDialogSelf', 'setShowJobTabCardDialogData']),

    // 显示浮窗
    showFixed (e) {
      // 清理上一个 要隐藏浮窗的定时器
      clearTimeout(this.jobTabCardDialogTimer)
      // 目标职位卡片距离内容区域父集的 top 值
      let targetDomOffsetTop = e.target.offsetTop
      // 职位卡片内容区域父集的 y 方向滚动距离
      let contentDomScrollY = this.jobTabCardContentScrollY
      // 职位卡片浮窗的 top 值
      let fixedDomTop = targetDomOffsetTop - contentDomScrollY
      // 拿到最外侧父集的高度
      let fatherDomHeight = document.getElementById('sidebarJobWrapper') && document.getElementById('sidebarJobWrapper').clientHeight
      // 职位卡片浮窗的 height 值
      let fixedDomHeight = 360

      // 防止浮窗超出上下边界，所以需要边界检查
      // 1. 上边界检测：小于 0 说明超出了上边界
      if (fixedDomTop < 0) {
        fixedDomTop = 0
      }
      // 2. 下边界检测：如果职位卡片浮窗 的 top 值 和 height 值的和 大于最外侧父集的高度 说明会超出下边界
      if ((fixedDomTop + fixedDomHeight) > fatherDomHeight) {
        fixedDomTop = fatherDomHeight - fixedDomHeight
      }

      this.setJobTabCardDialogTop(fixedDomTop)
      this.setShowJobTabCardDialogData(this.cardData)
      this.setShowJobTabCardDialog(true)
    },
    // 隐藏浮窗
    hiddenFixed () {
      let timer = setTimeout(() => {
        clearTimeout(this.jobTabCardDialogTimer)
        this.setShowJobTabCardDialog(false)
      }, 150)
      this.setJobTabCardDialogTimer(timer)
    },
    // 跳转到职位详情
    handleClickToDetail(data){
      window.open(`/jobs/${data.token}.html`,'_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .job-item-box{
    position: relative;
    cursor: pointer;
    background: #FFFFFF;
    box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.08);
    border-radius: 6px;
    margin-top: 10px;
    padding: 16px 16px 13px 16px;
    box-sizing: border-box;

    &:hover{
      box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.14);

      .fixed-box {
        display: block;
      }
    }

    &.downloadCardStyle {
      box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.01);

      &:hover {
        box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.1);
      }
    }

    .job-base{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
      .job-title{
        max-width: 160px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 500;
        color: #404040;
        line-height: 20px;
      }
      .job-salary{
        font-size: 14px;
        font-weight: 600;
        color: #FF6644;
        line-height: 20px;
      }
    }

    .job-info{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      height: 21px;
      overflow: hidden;
      & > span{
        padding: 2px 6px;
        margin-right: 6px;
        background: rgba(31, 80, 171, 0.03);
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 17px;
      }
    }

    .company-info{
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px dotted #ECECEC;
      margin-bottom: 9px;
      & > .job-company-logo{
        width: 24px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #ECECEC;
        margin-right: 2px;
      }
      & > span {
        padding: 0 6px;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        position: relative;
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        &::after{
          content: "";
          height:9px;
          width: 1px;
          background-color: #cfcfcf;
          position: absolute;
          right:0;
          top: 3px
        }
        &:last-child::after{
          display: none;
        }
      }
    }

    .matching{
      display: flex;
      align-items: center;
      .icon{
        width: 13px;
        height: 13px;
        background: #FF8569;
        border-radius: 2px;
        font-size: 11px;
        line-height: 13px;
        text-align: center;
        color: #fff;
        margin-right: 6px;
      }
      .content{
        font-size: 12px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 17px;
      }
    }

    .fixed-box {
      cursor: default;
      display: none;
      position: absolute;
      top: 142px;
      left: -12px;
      z-index: 1;
      width: 300px;
      background: #fff;
      box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.14);
      border-radius: 6px;
      padding: 16px 0 0;

      .fixed-title {
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;

        >span:first-of-type {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #404040;
          line-height: 22px;
          max-width: 170px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        >span:last-of-type {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FF6644;
          line-height: 22px;
        }
      }

      .fixed-tags {
        padding: 0 16px;
        display: flex;
        margin-bottom: 6px;

        >span {
          padding: 2px 6px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 17px;
          background: #F9F9F9;
          border-radius: 4px;
          margin-right: 6px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      .fixed-company {
        padding: 0 16px;
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #f9f9f9;

        >img {
          width: 24px;
          height: 24px;
          border-radius: 2px;
          border: 1px solid #ECECEC;
          margin-right: 8px;
        }

        &>span {
          padding: 0 6px;
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          line-height: 14px;
          position: relative;
          overflow: hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
          &::after{
            content: "";
            height:9px;
            width: 1px;
            background-color: #cfcfcf;
            position: absolute;
            right:0;
            top: 3px
          }
          &:last-child::after{
            display: none;
          }
        }
      }

      .fixed-jd {
        max-height: 188px;
        overflow-y: auto;
        padding: 16px 16px 0;

        >span {
          display: block;
          font-size: 13px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 14px;
          margin-bottom: 10px;
        }

        >p {
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          line-height: 20px;
        }
      }

      .fixed-btn-box {
        display: flex;
        justify-content: space-between;
        padding: 10px 16px 16px;

        .fixed-btn {
          cursor: pointer;
          width: 130px;
          height: 36px;
          border-radius: 18px;
          line-height: 36px;
          text-align: center;

          &:hover {
            opacity: 0.8;
          }

          &:first-of-type {
            background: url('https://files.wondercv.com/pc-vue/editor/job-fixed-btn-bg.png');
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            font-size: 14px;
            font-weight: 400;
            color: #FF6644;
          }

          &:last-of-type {
            background: linear-gradient(135deg, #FFA75E 0%, #FF6644 100%);
            font-size: 14px;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }

    }

  }
</style>
